module.exports = __webpack_public_path__ + "static/media/techo-cristal.1cd97e4c.png";